var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.184211,
    y: 0.184211,
    width: 27.6316,
    height: 27.6316,
    rx: 3.5,
    fill: "#C66060",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.184211,
    y: 0.184211,
    width: 27.6316,
    height: 27.6316,
    rx: 3.5,
    stroke: "#D7D7D7",
    strokeWidth: 0.368421
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7901_40612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 6.125C12.7934 6.125 11.1863 6.61252 9.81933 7.52591C8.45234 8.4393 7.38691 9.73753 6.75775 11.2564C6.1286 12.7754 5.96399 14.4467 6.28473 16.0592C6.60547 17.6717 7.39715 19.1528 8.55968 20.3153C9.7222 21.4778 11.2033 22.2695 12.8158 22.5903C14.4283 22.911 16.0996 22.7464 17.6186 22.1172C19.1375 21.4881 20.4357 20.4227 21.3491 19.0557C22.2625 17.6887 22.75 16.0816 22.75 14.4375C22.75 12.2329 21.8742 10.1186 20.3153 8.55967C18.7564 7.00078 16.6421 6.125 14.4375 6.125ZM7.16407 14.4375C7.16456 12.6897 7.79753 11.0012 8.94606 9.68379L19.1912 19.9289C18.1375 20.8388 16.8449 21.4272 15.4668 21.6242C14.0886 21.8212 12.6829 21.6186 11.4165 21.0403C10.1501 20.4621 9.0763 19.5326 8.32251 18.3622C7.56872 17.1918 7.16666 15.8296 7.16407 14.4375ZM19.9289 19.1912L9.68379 8.94605C11.0779 7.78123 12.8574 7.18027 14.6723 7.26141C16.4871 7.34255 18.2059 8.09991 19.4905 9.38449C20.7751 10.6691 21.5325 12.3879 21.6136 14.2027C21.6947 16.0176 21.0938 17.7971 19.9289 19.1912Z",
    fill: "#C66060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7901_40612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAppointment);
export default __webpack_public_path__ + "static/media/deleteAppointment.46eb784621200913b2be3b79cff4f8da.svg";
export { ForwardRef as ReactComponent };